import { render } from "./InventoryItem.vue?vue&type=template&id=afc94884&scoped=true"
import script from "./InventoryItem.vue?vue&type=script&lang=ts"
export * from "./InventoryItem.vue?vue&type=script&lang=ts"

import "./InventoryItem.vue?vue&type=style&index=0&id=afc94884&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-afc94884"

export default script